class GetQueryParam {
    constructor() {
        this.arg = new Object;
        let pair = location.search.substring(1).split('&');
        for(let i = 0; pair[i]; i++) {
            let kv = pair[i].split('=');
            this.arg[kv[0]] = kv[1];
        }

        return this.arg;
    }
}

export default GetQueryParam;